import type {SingleSelectOptionModalProps as SharedSingleSelectOptionModalProps} from '@github-ui/shared-single-select-components/SingleSelectOptionModal'
import {SingleSelectOptionModal as SharedSingleSelectOptionModal} from '@github-ui/shared-single-select-components/SingleSelectOptionModal'

import {getInitialState} from '../../../helpers/initial-state'

type SingleSelectOptionModalProps = Omit<SharedSingleSelectOptionModalProps, 'maxLength'>

export const SingleSelectOptionModal = (props: SingleSelectOptionModalProps) => {
  const maxLength = getInitialState().projectLimits.singleSelectDescriptionMaxLength
  return <SharedSingleSelectOptionModal {...props} maxLength={maxLength} noDuplicatedOptions={false} />
}

try{ SingleSelectOptionModal.displayName ||= 'SingleSelectOptionModal' } catch {}